import type { TokenProviderRepository } from '@/shared/contracts/tokenProvider.repository';
import { authStoreAccessRepository } from './authStoreAccess.repository';

/**
 * Implementación del proveedor de tokens usando repositorio centralizado
 * Cumple con DIP - implementa abstracción del dominio
 * MEJORADO: Usa repositorio centralizado para eliminar duplicación
 */
class StoreTokenProviderRepository implements TokenProviderRepository {
  /**
   * Obtiene el token actual del store de autenticación
   * @returns Token JWT o null si no existe
   */
  getCurrentToken(): string | null {
    return authStoreAccessRepository.getCurrentToken();
  }
}

export const storeTokenProviderRepository = new StoreTokenProviderRepository();
